import { createAsyncThunk } from '@reduxjs/toolkit';

import { ITimecardDetailDTO, ITimecardPeriodDTO, ITimecardSummaryDTO } from 'src/api/dtos';
import TimecardRepository from 'src/api/repositories/ess/v1/timecard.repository';
import { PeriodTypeEnums } from 'src/shared/enums';
import { isDateWithinCurrentWeek } from 'src/shared/utils';

export const fetchTimecardPeriods = createAsyncThunk<
  { periods: ITimecardPeriodDTO[]; currentSummary: ITimecardSummaryDTO | null },
  PeriodTypeEnums
>('timecard/periods', async (periodType: PeriodTypeEnums, { dispatch, rejectWithValue }) => {
  try {
    const repository = new TimecardRepository();

    const periods = await repository.getPeriods(periodType);

    const currentPeriod = periods.find((period) => isDateWithinCurrentWeek(period.startDate)) || periods[0];

    const currentSummary = await repository.getSummary(currentPeriod.periodId);
    dispatch(fetchTimecardSummary(currentPeriod.periodId));
    dispatch(fetchTimecardDetails(currentPeriod.periodId));

    return { periods, currentSummary };
  } catch (e) {
    return rejectWithValue(e);
  }
});

export const fetchTimecardSummary = createAsyncThunk<ITimecardSummaryDTO, number>(
  'timecard/summary',
  async (periodId: number, { rejectWithValue }) => {
    try {
      const repository = new TimecardRepository();
      return await repository.getSummary(periodId);
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const fetchTimecardDetails = createAsyncThunk<ITimecardDetailDTO[], number>(
  'timecard/details',
  async (periodId: number, { rejectWithValue }) => {
    try {
      const repository = new TimecardRepository();
      return await repository.getDetails(periodId);
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
